import { useGeneralSettingsFormData } from "@/api/cms";
import { DecoupageManagerBody } from "@/components/cms/DecoupageManager";
import { CmsAdminShell } from "@/pages/cms/advanced/AdminShell";
import { useCmsNew } from "@/lib/cms/cms-new-i18n";
import { cmsPhrase } from "@/lib/cms/cms-new-phrases";

/**
 * Section « Découpages » de l'interface WordPress-like du CMS avancé
 * (`/cms/advanced/decoupages`) : gestion centralisée des découpages du catalogue
 * raisonné (grille de navigation par cible Œuvres / Multiples). Donnée partagée
 * au niveau CMS (`CatalogueRaisonneSection`) — le bloc CMS avancé `CatalogueDecoupages`
 * ne fait plus qu'afficher/choisir, cet onglet est la source unique de gestion.
 *
 * En mode CR mixte (`CMS.isMixedCRMode`), le catalogue œuvres+multiples est
 * fusionné → un seul jeu de découpages (cible Œuvres).
 */
export default function CMSAdvancedDecoupages() {
  const cmsNew = useCmsNew();
  const { data: generalSettings } = useGeneralSettingsFormData();
  const isMixedCRMode = generalSettings?.isMixedCRMode ?? false;

  return (
    <CmsAdminShell
      title={cmsNew("cms.new.auto.title.decoupages", "Découpages")}
      subtitle={
        isMixedCRMode
          ? cmsPhrase(cmsNew, "decoupagesSubtitleMixed")
          : cmsPhrase(cmsNew, "decoupagesSubtitleDefault")
      }
    >
      <div className="px-6 py-4">
        <DecoupageManagerBody isMixedCRMode={isMixedCRMode} />
      </div>
    </CmsAdminShell>
  );
}
